<template>
    <div class="flex min-w-full justify-center flex-col items-center">
        <div>
            <div class="flex flex-col text-center mb-4 md:mb-8 px-12">
                <!-- customer.forename | capitalize  -->
                <span class="text-green-500 text-3xl font-bold mb-2 mt-6">Thanks, {{ forename }}</span>
                <span class="text-gray-800 sm:text-xl sm:px-6 mt-4" v-if="progressPercentage <= 39 && this.form.showDefaultSpinnerText === true">
                    We’re working hard to match you with the best deal…
                </span>
                <span class="text-gray-800 sm:text-xl sm:px-6 mt-4" v-if="progressPercentage >= 40 && progressPercentage < 70 && this.form.showDefaultSpinnerText === true">
                    Hold tight, we’re now comparing deals to see what’s a good fit...
                </span>
                <span class="text-gray-800 sm:text-xl sm:px-6 mt-4" v-if="progressPercentage >= 70 && this.form.showDefaultSpinnerText === true">
                    We’re nearly done, this shouldn’t take much longer...
                </span>
                <span class="text-gray-800 sm:text-xl sm:px-6 mt-4" v-if="this.form.postCompleteAction == 'mwg-signpost'">
                    After checking 30 lenders a loan wasn’t possible on this occasion – but don’t worry,<br class="xs:hidden lg:block">
                    we are passing you to our partner Money Wellness to look at alternatives
                </span>
                <span class="text-gray-800 sm:text-xl sm:px-6 mt-4" v-if="this.form.postCompleteAction == 'lender-signpost'">
                    Good news, You've been matched with a loan through {{ this.form.postCompleteLender }}.<br class="xs:hidden lg:block">
                    We'll redirect you now to complete your application.
                </span>
            </div>
            <div class="flex mb-4 md:mb-8">
                <div class="progress-bar-circle"
                    :class="this.form.postCompleteAction == 'mwg-signpost' || this.form.postCompleteAction == 'lender-signpost' ? 'complete tick' : ''">
                    <div class="progress-bar-inter">
                        <span class="inter-text">
                            You've been
                            <br />pre-approved
                        </span>
                        <br />
                        <span class="inter-tick"></span>
                    </div>
                    <span class="text" v-html="progress"></span>
                    <div class="tick"></div>
                    <div class="progress-circle progress-circle-1"></div>
                    <div class="progress-circle progress-circle-2"></div>
                    <div class="progress-circle progress-circle-3"></div>
                    <div class="progress-circle progress-circle-4"></div>
                    <div class="progress-circle progress-circle-5"></div>
                    <div class="progress-circle progress-circle-6"></div>
                    <div class="progress-circle progress-circle-7"></div>
                    <div class="progress-circle progress-circle-8"></div>
                    <div class="progress-circle progress-circle-9"></div>
                    <div class="progress-circle progress-circle-10"></div>
                </div>
            </div>
            <div class="flex flex-col px-12 text-lg text-center">
                <p v-if="this.form.showDefaultSpinnerText === true">This might take a minute.</p>
                <p v-if="this.form.showDefaultSpinnerText === true">Please don’t refresh the page.</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        forename: String,
        form: {},
    },
    methods: {
        startLoadingBar() {
            window.scrollTo(0,0);
            let timings = {
                100: 7000,
                90: 6800,
                80: 6300,
                70: 5000,
                51: 4000,
                46: 2000,
                40: 1000,
                30: 500,
                20: 200,
                0: 200
            };
            var getTiming = function(iterator) {
                for (var k in timings) {
                    if (Object.prototype.hasOwnProperty.call(timings, k)) {
                        k = parseInt(k, 10);
                        if (Object.prototype.hasOwnProperty.call(timings, k) && iterator < k) {
                            return timings[k];
                        }
                    }
                }
            };
            // Start the loop
            var i = 0;
            var timeoutLoop = () => {
                if (i >= 100) {
                    return false;
                }
                i++;
                var timing = getTiming(i);
                this.progress = (i < 10 ? '&nbsp;' : '') + i + '<small>%</small>';
                this.progressPercentage = i;
                window.progressBarTimeout = setTimeout(timeoutLoop, timing);
            };
            timeoutLoop();
        }
    },
    data() {
        return {
            customer: this.customerData || {},
            progress: 1, 
            progressPercentage: 1,
                };
    },
    mounted() {
        this.startLoadingBar();
    }
};
</script>

<style lang="scss" scoped>
.progress-bar-circle {
    position: relative;
    width: 140px;
    height: 190px;
    padding: 0;
    margin: 50px auto;
    border-radius: 50%;
    @screen md {
        height: 210px;
    }
}

.progress-bar-circle .progress-bar-inter {
    opacity: 0;
    visibility: hidden;
}

.progress-bar-circle .progress-bar-inter .inter-tick {
    display: inline-block;
    width: 90px;
    height: 68px;
    background-image: url("/img/inter-tick.png");
    background-size: 90px 68px;
    margin-top: 30px;
    transform: scale(0.66);
}

@media (-webkit-min-device-pixel-ratio: 1.25), (min-resolution: 120dpi) {
    .progress-bar-circle .progress-bar-inter .inter-tick {
        background-image: url("/img/inter-tick@2x.png");
    }
}

@media (-webkit-min-device-pixel-ratio: 2.25), (min-resolution: 216dpi) {
    .progress-bar-circle .progress-bar-inter .inter-tick {
        background-image: url("/img/inter-tick@3x.png");
    }
}

@media (min-width: 992px) {
    .progress-bar-circle .progress-bar-inter .inter-tick {
        transform: scale(1);
    }
}

.progress-bar-circle .tick {
    top: 75px;
    left: 25px;
    display: block;
    position: absolute;
    width: 90px;
    height: 68px;
    background-size: 90px 68px;
    background-image: url("/img/form/progress-tick.png");
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.25s linear;
}

@media (-webkit-min-device-pixel-ratio: 1.25), (min-resolution: 120dpi) {
    .progress-bar-circle .tick {
        background-image: url("/img/form/progress-tick@2x.png");
    }
}

@media (-webkit-min-device-pixel-ratio: 2.25), (min-resolution: 216dpi) {
    .progress-bar-circle .tick {
        background-image: url("/img/form/progress-tick@3x.png");
    }
}

.progress-bar-circle .progress-circle {
    transition: opacity 1s linear;
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 31px;
    height: 31px;
    margin: -15.5px;
    animation-fill-mode: forwards;
}

.progress-bar-circle .progress-circle.progress-circle-10 {
    transform: rotate(-90deg) translate(100px) rotate(90deg);
    animation-delay: 1.5s;
    opacity: 0.1;
}

.progress-bar-circle .progress-circle.progress-circle-9 {
    transform: rotate(-126deg) translate(100px) rotate(126deg);
    animation-delay: 1.35s;
    opacity: 0.2;
}

.progress-bar-circle .progress-circle.progress-circle-8 {
    transform: rotate(-162deg) translate(100px) rotate(162deg);
    animation-delay: 1.2s;
    opacity: 0.3;
}

.progress-bar-circle .progress-circle.progress-circle-7 {
    transform: rotate(-198deg) translate(100px) rotate(198deg);
    animation-delay: 1.05s;
    opacity: 0.4;
}

.progress-bar-circle .progress-circle.progress-circle-6 {
    transform: rotate(-234deg) translate(100px) rotate(234deg);
    animation-delay: 0.9s;
    opacity: 0.5;
}

.progress-bar-circle .progress-circle.progress-circle-5 {
    transform: rotate(-270deg) translate(100px) rotate(270deg);
    animation-delay: 0.75s;
    opacity: 0.6;
}

.progress-bar-circle .progress-circle.progress-circle-4 {
    transform: rotate(-306deg) translate(100px) rotate(306deg);
    animation-delay: 0.6s;
    opacity: 0.7;
}

.progress-bar-circle .progress-circle.progress-circle-3 {
    transform: rotate(-342deg) translate(100px) rotate(342deg);
    animation-delay: 0.45s;
    opacity: 0.8;
}

.progress-bar-circle .progress-circle.progress-circle-2 {
    transform: rotate(-378deg) translate(100px) rotate(378deg);
    animation-delay: 0.3s;
    opacity: 0.9;
}

.progress-bar-circle .progress-circle.progress-circle-1 {
    transform: rotate(-414deg) translate(100px) rotate(414deg);
    animation-delay: 0.15s;
    opacity: 1;
}

.progress-bar-circle .text {
    transition: opacity 0.25s linear;
    font-size: 44px;
    line-height: 44px;
    font-weight: bold;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    color: theme("colors.green.default");
}

.progress-bar-circle .text small {
    font-size: 32px;
}

@media (min-width: 992px) {
    .progress-bar-circle .text {
        font-size: 48px;
    }
}

.progress-bar-circle .progress-circle {
    width: 31px;
    height: 31px;
    border-radius: 50%;
    background-color: theme("colors.green.default");
    animation: progress-circle-animation 1.5s infinite;
}

.progress-bar-circle.complete .progress-circle {
    animation: none !important;
    opacity: 1 !important;
}

.progress-bar-circle.complete .text {
    visibility: hidden;
    opacity: 0;
}

.progress-bar-circle.complete .tick {
    visibility: visible;
    opacity: 1;
}

.progress-bar-circle.inter {
    background-color: theme("colors.green.default");
    height: 220px;
    width: 220px;
    margin-top: 0px;
    margin-bottom: 0px;
}

@media (min-width: 992px) {
    .progress-bar-circle.inter {
        height: 338px;
        width: 338px;
        margin-top: 50px;
        margin-bottom: 50px;
    }
}

.progress-bar-circle.inter .progress-circle {
    display: none;
}

.progress-bar-circle.inter .text {
    display: none;
}

.progress-bar-circle.inter .progress-bar-inter {
    opacity: 1;
    visibility: visible;
    text-align: center;
}

.progress-bar-circle.inter .progress-bar-inter .inter-text {
    color: #fff;
    text-align: center;
    margin-top: 40px;
    font-size: 24px;
    line-height: 30px;
    font-weight: bold;
    display: inline-block;
}

@media (min-width: 992px) {
    .progress-bar-circle.inter .progress-bar-inter .inter-text {
        line-height: 40px;
        margin-top: 60px;
        font-size: 34px;
    }
}

@keyframes progress-circle-animation {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0.1;
    }
}
</style>